"use client"

import { FolderMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FolderMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FolderMinusIcon = component(Icon)({ as: FolderMinus })
